import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import http from '@/http'
import {Message} from 'element-ui'

// modules

import docStore from './docStore'
import statsStore from './statsStore'
import warningStore from './warningStore'

import home from './modules/home'
import device from './modules/device'
import echarts from './modules/echarts'
import history from './modules/history'
import alarm from './modules/alarm'

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [createPersistedState({
    key: 'xj_electric'
  })],
  modules: {
    home,
    echarts,
    device,
    history,
    alarm,



    docStore,
    statsStore,
    warningStore,

  },
  state: {




    voiceConfig: {
      electricity: false,
      temperature: false,
      leakage: false,
      boxTemperature: false
    },
    randomCode: '', //随机验证码
    sub_navs: [],
    deviceList: {
      data: []
    },
    deviceDetail: {},
    deviceTypeLineChart: {},
    breadcrumbs: [
      {
        pid: '0',
        areaName: '智慧用电监管服务平台'
      }
    ],
    breadcrumb: [
      {
        pid: '0',
        areaName: '智慧用电监管服务平台'
      }
    ],
    deviceTypeVisible: true,
    currentKey: 'now',
    categoryList: [],
    isDeviceList: false,
    device_version: '',
    showType: 'card',
    pageviewLoading: false,
    pid: '',
    //当前页码
    page: 1,

    router_key: 'AREA',
    device_key: 'electric',

    // 纪录路由的类型： 区域 设备列表 列表详情
    currentRouterType: '',
    realtimeWarningList: [],
    eledegMonth: {},
    outsideComponentName: '',
    outComponentVisible: false,
    outComponentLoading: false,
    deviceCbList: [],
    totalRealtimeLength: 0,
    username: '',
    xlsxName: '',
    creatTime: '',
    bPhaseCurr: '',
    cPhaseCurr: '',
    historyEledeg: [],
    zongHeListData: [],   //综合页面
    zongheId: 1,    //记录进入综合页面
    zongheCId: '',  //记录进入综合页面传的id
    regionId: '',   //记录地区跳转的ID
    detailId: '',   //进入设备页记录code
    count: 0,
  },

  mutations: {
    setLoading(state, data) {
      state.loading = data
    },





    mytest(state, version) {
      state.my = version  //设备版本

    },
    deviceCbList(state, data) {
      state.deviceCbList = data
    },
    creatTime(state, data) {
      state.creatTime = data
    },
    historyEledeg(state, data) {
      state.historyEledeg = data
    },
    detailIdChange(state, data) {
      state.detailId = data
    },
    regionIdChange(state, data) {
      state.regionId = data
    },
    zongheIdChange(state, data) {
      state.zongheId = data
    },
    zongheCIdChange(state, data) {
      state.zongheCId = data
    },
    excelName(state, xlsxName) {
      state.xlsxName = xlsxName
    },
    bPhaseCurr(state, bPhaseCurr) {
      state.bPhaseCurr = bPhaseCurr
    },
    cPhaseCurr(state, cPhaseCurr) {
      state.cPhaseCurr = cPhaseCurr
    },
    loginUserName(state, username) {
      state.username = username
    },
    totalRealtimeLength(state, len) {
      state.totalRealtimeLength = len
    },
    updateOutComponentLoading(state, loading) {
      state.outComponentLoading = loading;
    },
    showOutComponent(state) {
      state.outComponentVisible = true
    },
    fadeOutComponent(state) {
      state.outComponentVisible = false
    },
    outsideComponentName(state, componentName) {
      state.outsideComponentName = componentName
    },
    clearRealtime(state) {
      state.realtimeWarningList = []
    },
    updateRealtimeWarning(state, data) {
      state.realtimeWarningList = data;
    },
    eledegMonth(state, data) {
      state.eledegMonth = data;
    },
    clearRealtimeList(state) {
      state.realtimeWarningList = [];
    },
    submitRealtimeWarning(state, data) {
      state.realtimeWarningList.unshift(data)
    },
    voiceConfig(state, config) {
      state.voiceConfig = config;
    },
    updateCurrentRouterType(state, type) {
      state.currentRouterType = type;
    },
    toggleDeviceType(state, val) {
      state.deviceTypeVisible = val
    },
    docList(state, data) {
      console.log(data)
    },
    randomCode(state, code) {
      state.randomCode = code;
    },
    DEVICE_KEY(state, key) { //设备类型
      state.device_key = key
    },
    updatePid(state, pid) {
      state.pid = pid
    },
    updatePage(state, page) { //当前页码
      state.page = page
    },
    CURRENT_KEY(state, key) {
      state.currentKey = key
    },
    UPDATE_BREAD(state, data) {
      state.breadcrumbs.push(data)
    },
    updataBread(state, data) {
      state.breadcrumb.push(data)
    },
    DEVICE_TYPE(state, type) {
      state.deviceType = type  //设备版本
    },
    DEVICE_VERSION(state, version) {
      state.deviceVersion = version  //设备版本
    },
    POP_BREAD(state, data) {
      if (data == 'clear') {
        state.breadcrumbs = [
          {
            pid: '-1',
            areaName: '智慧用电监管服务平台'
          }
        ]
      } else {
        state.breadcrumbs.pop();
      }
    },
    REACT_DEVICE(state, data) {
      state.deviceList = data
    },
    DEVICE_DETAIL(state, data) {
      state.deviceDetail = data
    },
    LINE_CHART(state, data) {
      state.deviceTypeLineChart = data
    },
    REACT_CATEGORY(state, data) {
      state.categoryList = data
    },
    isDeviceList(state, value) {
      state.isDeviceList = value
    },
    // Device_BREAD(state,id){
    //   http.post(`/api/device/dispose`, {
    //     id:id
    //   }).then( res => {
    //     console.log('+++++');
    //     var a =JSON.stringify(res);
    //     a=JSON.parse(a);
    //     var b = 0;
    //     for (var i = 1; i < 8; i++) {
    //       if(a[i] !== undefined){
    //         b++;
    //       }
    //     }
    //     for (var x = 8-b;x < 8;x++){
    //       store.commit('UPDATE_BREAD', {
    //         areaName: res[x]
    //       })
    //     }
    //   })
    // },
    // 更新显示类型 卡片|表格
    UPDATE_SHOWTYPE(state, type) {
      state.showType = type;
    },
    LOAD(state, type) {
      if (type == 0) {
        state.pageviewLoading = true;
      } else {
        state.pageviewLoading = false
      }
    },

    // Save router state
    ROUTER_KEY(state, value) {
      state.router_key = value
    },
    zongHeListDataChange(state, data) {
      state.zongHeListData = data
    },
  },
  actions: {
    device_list({commit}, data) {
      // commit('DEVICE_LIST', data)
      console.log(data)

    },
    device_detail({commit}, data) {
      commit('DEVICE_DETAIL', data)
    },
    device_type_line_chart({commit}, data) {
      commit('LINE_CHART', data)
    },
    react_category({commit}, data) {
      commit('REACT_CATEGORY', data)
    },

    device_bread({commit}, data) {
      commit('Device_BREAD', data)
//    console.log(data)
    },

    checkChild({commit, state}) {
      commit('REACT_CATEGORY', [])

      http.post('/api/index', {
        parentId: state.pid,
        pageSize: 12,
        deviceType: (state.device_key == 'airswitch' ? 2 : (state.device_key == 'smokesensor' ? 3 : (state.device_key == 'combgas' ? 4 : 1))),
        // deviceType: (state.device_key == 'airswitch' ? 2 : (state.device_key == 'smokesensor' ? 3 : (state.device_key == 'combgas' ? 4 : 1))),
        pageNum: state.page  //当前页码
      }).then(res => {
        // console.dir(res)
        // commit('LOAD', 1)
        res.data.forEach(item => {
          item.pid = state.pid
        })
        commit('REACT_CATEGORY', res)
      }).catch(error => {
        Message({type: 'error', message: error})
        //  commit('LOAD', 1)
        console.log(error)
      })
    },
    // checkDeviceChild({commit, state}, {cid, keyword = '', startTime = '', endTime = ''}){
    checkDeviceChild({commit, state}) {
      // commit('LOAD', 0)
      // category_id : 栏目编号
      // deviceType: 设备分类编号 1 火灾探测器  2 空开设备
      // page: 当前页码
      commit('REACT_DEVICE', []);
      http.post(`/api/device/index`, {
        pageSize: 12,
        parentId: state.pid,
        //parentId: cid,
        deviceType: (state.device_key == 'electric' ? 1 : (state.device_key == 'smokesensor' ? 3 : (state.device_key == 'combgas' ? 4 : 2))),
        // deviceType: (state.device_key == 'electric' ? 1 : (state.device_key == 'smokesensor' ? 3 : (state.device_key == 'combgas' ? 4 : 2))),
        //  keyword,
        pageNum: state.page,
        // startTime,
        // endTime,
        // page: state.pid == 0 ? 1 : state.device_page
      }).then(res => {
        // console.dir(res)
        //  commit('LOAD', 1)
        if (res.data.length > 0) {
          res.data.forEach(item => item.pid = state.pid)
        }
        commit('REACT_DEVICE', res)
      }).catch(err => {
        Message({type: 'error', message: err.msg})
        //  commit('LOAD', 1)
      })
    },
    getCatePage({commit, state}) {
      //   commit('LOAD', 0)
      state.zongHeListDataChange = [];
      http.post('api/index/page', {
        parentId: state.pid,
        deviceType: (state.device_key == 'airswitch' ? 2 : (state.device_key == 'smokesensor' ? 3 : (state.device_key == 'combgas' ? 4 : 1))),
        pageNum: state.page,  //当前页码
        // pageSize: 12,
      }).then(res => {
        //  commit('LOAD', 1);
        // if (res.data.length > 0) {
        //   res.data.forEach(item => item.areaCode = state.pid)
        // }
        commit('zongHeListDataChange', res);
        //刷新
      })
    },
    getBreadcrumbs({commit, state}) {
      http.post('api/category/list', {
        areaCode: state.pid
      }).then(res => {
        commit('POP_BREAD', 'clear')
        for (var i = 1; i < res.length; i++) {
          commit('UPDATE_BREAD', res[i])
        }

      })
    }
  }
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js